import { render, staticRenderFns } from "./PartnersModule.vue?vue&type=template&id=04ea9f46&"
import script from "./PartnersModule.vue?vue&type=script&lang=js&"
export * from "./PartnersModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports